import { useParams } from 'react-router-dom';

export const usePatientId = () => {
  const { patientId } = useParams();
  return patientId;
};

export const useClientId = () => {
  const { clientId } = useParams();
  return clientId;
};
